export default "__VITE_ASSET__BLMu4cHr__"